<template>
  <customModal :containermd="true" @closeModal="closeModal">
    <template #title>
      <h4 class="my-0">{{ $t("navigations.unscheduled visit") }}</h4>
    </template>

    <template #body>
      <div class="form-group row">

        <!-- Visit No -->
        <div class="col-lg-3 my-0">
          <label class="col-form-label">
            {{ $t("navigations.visit no")}}<sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <input
            type="text"
            class="form-control"
            v-model="visitData.visitNo"
            maxlength="50"
          />
          <span class="errormsg" v-if="errors[0]">
            {{ $t("navigations.please enter visit no") }}
          </span>
        </div>

        <!-- Visit Name -->
        <div class="col-lg-3 my-0">
          <label class="col-form-label">
            {{ $t("navigations.visit name")}}<sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <input
            v-model="visitData.visitName"
            type="text"
            maxlength="1000"
            class="form-control"
          />
          <span class="errormsg" v-if="errors[1]">
            {{ $t("navigations.please enter visit/form name")}}
          </span>
        </div>

        <!-- Visit Type -->
        <div class="col-lg-3 my-0">
          <label class="col-form-label">
            {{ $t("navigations.visit type")}}<sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <select
            class="form-select"
            v-model="visitData.visitType"
          >
            <option value="">{{ $t("navigations.select") }}</option>
            <option v-for="options in visitTypes" :key="options.typename">
              {{ options.typename }}
            </option>
          </select>
          <span class="errormsg" v-if="errors[2]">
            {{ $t("navigations.please select a visit type") }}
          </span>
        </div>

        <div class="col-lg-3 my-0">
          <label class="col-form-label">
            Relation Type </label>
          <select class="form-select" placeholder="Visit Type" v-model="visitData.relationType" valueProp="VisitTypeName">
            <option value="Concurrent">Concurrent</option>
            <option value="Before" >Before</option>
            <option value="After" >After</option>
          </select>
          <!-- <span class="errormsg" v-if="errors[3] == false">{{
            $t("navigations.please select a relation type")
          }}</span> -->
        </div>

        <!-- Pre Visit -->
        <div class="col-lg-2 my-0">
          <label class="col-form-label">Pre-visit days</label>
          <input
            v-model="visitData.preVisit"
            type="number"
            class="form-control"
            :min="0"
            maxlength="4"
            @keydown="validateNumberInput($event, 'preVisit')"
            @change.prevent="numberonlyvalidation('preVisit')"
          />
          <span class="errormsg" v-if="numerrors['preVisit'] == false">
            {{ $t("navigations.please enter a number") }}
          </span>
        </div>

        <!-- Post Visit -->
        <div class="col-lg-2 my-0">
          <label class="col-form-label">Post-visit days</label>
          <input
            v-model="visitData.postVisit"
            type="number"
            class="form-control"
            :min="0"
            maxlength="4"
            @keydown="validateNumberInput($event, 'postVisit')"
            @change.prevent="numberonlyvalidation('postVisit')"
          />
          <span class="errormsg" v-if="numerrors['postVisit'] == false">
            {{ $t("navigations.please enter a number") }}
          </span>
        </div>

        <!-- Visit Date -->
        <div class="col-lg-3 my-0">
          <label class="col-form-label">
            {{ $t("navigations.visit date")}}<sup><i class="fa fa-asterisk required"></i></sup>
          </label>
           <flat-pickr v-model="visitData.visitDate" :config="dateTimePickerConfig"
                        class="fp-datetime-input w-100 visit-datetime-input" />
          <span class="errormsg" v-if="errors[3]">
            {{ $t("navigations.please enter visit date") }}
          </span>
        </div>

        <!-- Investigator -->
        <div class="col-lg-3 my-0">
          <label class="col-form-label">{{ $t("navigations.investigator") }}</label>
          <select class="form-control" v-model="visitData.investigator">
            <option value="">{{ $t("navigations.select") }}</option>
            <option v-for="user in users" :key="user.userID" :value="user.email">
              {{ user.name }}
            </option>
          </select>
        </div>

        <!-- Patient Visit Checkbox -->
        <div class="col-lg-2 align-self-end">
          <div class="i-checkss">
            <label class="mr-2">{{ $t("navigations.subject visit") }}</label>
            <input
              type="checkbox"
              v-model="visitData.isPatientVisit"
              :disabled="visitData.visitType == 'Patient Visit'"
            />
          </div>
        </div>

        <!-- Activity Fields -->
        <div class="col-lg-4 my-0">
          <label class="col-form-label">{{ $t("navigations.activity name") }}<sup><i class="fa fa-asterisk required"></i></sup></label>
          <select v-model="activityForm.selectedActivityId" class="form-select">
            <option value="">{{ $t("navigations.select") }}</option>
            <option v-for="activity in activityOptions" :key="activity.id" :value="activity.id">
              {{ activity.activityName }}
            </option>
          </select>
          <span class="errormsg" v-if="validations[0]">
            {{ $t("navigations.please select an activity") }}
          </span>
          <span class="errormsg" v-if="errors[4]">
            {{ $t("navigations.please add at least one activity") }}
          </span>
        </div>

        <div class="col-lg-3 my-0">
          <label class="col-form-label">{{ $t("navigations.activity order") }}<sup><i class="fa fa-asterisk required"></i></sup></label>
          <select v-model="activityForm.order" class="form-select">
            <option value="">{{ $t("navigations.select") }}</option>
            <option
              v-for="i in Array.from({ length: activityCount + 1 }, (_, index) => activityCount + 1 - index)"
              :key="i"
              :value="i"
            >
              {{ i }}
            </option>
          </select>
          <span class="errormsg" v-if="validations[1]">
            {{ $t("navigations.please select an activity order") }}
          </span>
        </div>

        <!-- NEW: Is Required checkbox for add -->
        <div class="col-lg-2 my-0 align-self-end">
          <div class="form-check">
            <input
              type="checkbox"
              v-model="activityForm.isRequired"
              class="form-check-input"
              id="isRequiredAdd"
            />
            <label class="form-check-label" for="isRequiredAdd">
              {{ $t("navigations.required") }}
            </label>
          </div>
        </div>

        <div class="col-lg-2 align-self-center py-4">
          <button class="save_btn py-1 px-3 w-100" @click="addActivity()">
            {{ $t("navigations.add activity") }}
          </button>
        </div>

        <!-- Activity Table -->
        <div class="row align-items-end w-100">
          <div v-if="activityCount == 0" class="text-center py-3">
            {{ $t("navigations.no activities found") }}
          </div>
          <div v-else class="col-lg-12 mt-3">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>{{ $t("navigations.activity order") }}</th>
                  <th>{{ $t("navigations.activity name") }}</th>
                  <th>{{ $t("navigations.status") }}</th>
                   <th>{{ $t("navigations.required") }}</th>
                  <th class="text-center">{{ $t("navigations.forms") }}</th>
                  <th class="text-center">{{ $t("navigations.edit") }}</th>
                  <th class="text-center">{{ $t("navigations.delete") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in activityList" :key="index">
                  <td>
                    <div v-if="editingIndex === index">
                      <select v-model="editedActivity.activityOrder" class="form-select">
                        <option value="">{{ $t("navigations.select") }}</option>
                        <option v-for="order in activityOrderOptions(true)" :key="order" :value="order">
                          {{ order }}
                        </option>
                      </select>
                    </div>
                    <div v-else>{{ item.activityOrder }}</div>
                  </td>

                  <td>
                    <div v-if="editingIndex === index">
                      <select v-model="editedActivity.activityId" class="form-select">
                        <option value="">{{ $t("navigations.select") }}</option>
                        <option v-for="activity in activityOptions" :key="activity.id" :value="activity.id">
                          {{ activity.activityName }}
                        </option>
                      </select>
                    </div>
                    <div v-else>{{ item.activityName }}</div>
                  </td>

                  <td>{{ item.status }}</td>
                    <!-- <td>
                    <div v-if="editingIndex === index">
                      <input type="checkbox" v-model="editedActivity.isRequired" class="form-check-input" />
                    </div>
                    <div v-else>
                      <span v-if="item.isRequired">✔</span>
                      <span v-else>✘</span>
                    </div>
                  </td> -->
                         <td class="text-center">
  <!-- Editing mode -->
  <div class="i-checks" v-if="editingIndex === index">
    <input type="checkbox" v-model="editedActivity.isRequired" />
  </div>
  <!-- View mode -->
  <div  class="i-checks" v-else >
    <input type="checkbox" :checked="item.isRequired == true ? true : false" disabled />
  </div>
</td>
                  <td class="text-center">
                    <i class="fa fa-file-text edit-delete" @click="openActivityFormsModal(item.activityId)"></i>
                  </td>
                  <td class="text-center">
                    <div v-if="editingIndex === index">
                      <i class="fa fa-save text-success cursor-pointer me-2" @click="saveEditedActivity(index)"></i>
                      <i class="fa fa-times text-danger cursor-pointer" @click="cancelEdit"></i>
                    </div>
                    <div v-else>
                      <i class="fa fa-edit text-primary cursor-pointer" @click="editActivity(index)"></i>
                    </div>
                  </td>
                  <td class="text-center">
                    <i class="fa fa-trash text-danger cursor-pointer" @click="removeActivity(index)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Save Button -->
        <div class="text-center">
          <button class="save_btn py-1 px-4 mt-3" @click.prevent="addUnscheduledVisit()">
             <span v-if="showCreateLoader == false">Save</span>
            <span v-else><i class="fa fa-spinner fa-spin"></i></span>
          </button>
        </div>
      </div>
    </template>
  </customModal>
  <FormListVueModal v-if="showActivityForms" :soaId="soaId" @closeModal="closeModalForms" />
</template>

<script src="./UnscheduledVisitModal.js"></script>
<style scoped>
:deep(.fp-datetime-input.flatpickr-input),
:deep(.fp-datetime-input.flatpickr-input:focus),
:deep(.fp-datetime-input.flatpickr-input.active) {
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #e5e6e7;
  border-radius: 1px;
  color: inherit;
  display: block;
  width: 100%;
  min-height: 28px;
  padding: 3px 12px;
  font-size: 13px;
  line-height: 1.42857143;
  box-sizing: border-box;
  box-shadow: none;
  outline: none;
  transition: none;
}

:deep(.fp-datetime-input.flatpickr-input:focus),
:deep(.fp-datetime-input.flatpickr-input.active) {
  border-color: #145faf;
}

:deep(input.fp-datetime-input.flatpickr-input.active) {
  position: static !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  display: block !important;
}

:deep(.fp-datetime-input.flatpickr-input:disabled) {
  background-color: #e9ecef;
  cursor: not-allowed;
}
.form-check-label {
    margin-bottom: 24px;
}
</style>
